/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { SetupTotpPayload } from 'api/actions/setup-totp/setup-totp-payload';
import { SetupTotpPathParameters } from 'api/actions/setup-totp/setup-totp-path-parameters';
import { SetupTotpResponse } from 'api/actions/setup-totp/setup-totp-response';

type SetupTotpQueryParameters = Record<string, any>;

/**
 * The path of the SetupTotp action.
 */
export const setupTotpActionPath = new SweetPath<keyof SetupTotpPathParameters>('/user/totp/setup', {
  path: '{param}',
});

/**
 * Creates a contextualized SetupTotp actions.
 */
export default function createSetupTotpAction(axios: AxiosInstance) {
  return function setupTotpAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: SetupTotpQueryParameters;
    payload: SetupTotpPayload;
  }) {
    const path = setupTotpActionPath.original;

    return axios.post<SetupTotpResponse, SetupTotpResponse, SetupTotpPayload>(path, payload);
  };
}
